export const colors = {
  white: '#fff',
  lightGrey: '#ddd',
  lightGrey2: '#f5f5f5',
  lightGrey3: '#cdcdcd',
  lightGrey4: '#ececec',
  lightGrey5: '#9F9F9F',
  darkGray: '#363636',
  darkGray2: '#a2a2a2',
  grey: '#ccc',
  lightYellow: '#ffd773',
  yellow: '#f9bc3e',
  orange: '#f28b1b',
  magenta: '#d22542',
  rose: '#f05b5c',
  danger500: '#E13233',
  darkRed: '#a80000',
  green: '#00c853',
  black: '#000',
  black900: '#2a2828',
  black100: '#B9C3CA',
  black500: '#3E4F60',
  pumpkin: '#FF6700',
};
